/* src/app/modules/shared/components/dialogs/confirm-dialog/confirm-dialog.component.css */
/*# sourceMappingURL=confirm-dialog.component.css.map */
